import { createRootRoute } from '@tanstack/react-router';
import { ComposedWrapper } from '../compose/app-wrapper.js';
import { NavPanes } from '../nav/index.js';
import { AppRoot } from '../shell/app-root.js';

/**
 * The token root of the whole app (1.I-1): Noir, the layer rule, notices, then the frame or the
 * page. 1.I-2 passes its open-modes provider as `Wrapper` and its split pane and palette as `Content`.
 */
function RootComponent() {
  return <AppRoot Wrapper={ComposedWrapper} Content={NavPanes} />;
}

export const Route = createRootRoute({
  component: RootComponent,
});
